var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.items.length > 0,
          expression: "items.length > 0"
        }
      ]
    },
    [
      _vm._m(0),
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "div",
          { key: `additional-payment-item-${index}`, staticClass: "row mb-3" },
          [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "bg-secondary-9 rounded p-md-3 p-2" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-2 col-sm-12 pr-3 pr-md-0 pr-sm-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "row bg-white m-1 p-3 rounded" },
                        [
                          _vm._m(1, true),
                          _c("div", [
                            _c(
                              "span",
                              { staticClass: "color-gray-6 font-14" },
                              [_vm._v("Pago Adicional:")]
                            ),
                            _c(
                              "div",
                              { class: _vm.amountClass(item.additionalAmount) },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getAdditionalAmount(
                                        item.additionalAmount
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-10 col-sm-12 pl-3 pl-md-0 pl-sm-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "row bg-white m-1 p-3 rounded pb-4" },
                        [
                          _c("div", { staticClass: "col d-flex pb-2" }, [
                            _c("em", {
                              staticClass:
                                "fas fa-file-invoice color-orange mt-1"
                            }),
                            _c("div", { staticClass: "pl-3" }, [
                              _c(
                                "span",
                                { staticClass: "color-gray-6 font-14" },
                                [_vm._v("Número de Jornal:")]
                              ),
                              _c(
                                "div",
                                { staticClass: "color-black font-16" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.journalNumber || "-") +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "col d-flex" }, [
                            _c("em", {
                              staticClass:
                                "fas fa-calendar-edit color-orange mt-1"
                            }),
                            _c("div", { staticClass: "pl-3" }, [
                              _c(
                                "span",
                                { staticClass: "color-gray-6 font-14" },
                                [_vm._v("Fecha de Pago:")]
                              ),
                              _c(
                                "div",
                                { staticClass: "color-black font-16" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("date")(item.paymentDate)) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "col d-flex" }, [
                            _c("em", {
                              staticClass: "fas fa-edit color-orange mt-1"
                            }),
                            _c("div", { staticClass: "pl-3" }, [
                              _c(
                                "span",
                                { staticClass: "color-gray-6 font-14" },
                                [_vm._v("Comentario:")]
                              ),
                              _c(
                                "div",
                                { staticClass: "color-black font-16" },
                                [_vm._v(" " + _vm._s(item.comment) + " ")]
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-2 col-sm-12 pl-4 pl-md-5 pl-sm-4 ml-4 ml-md-5 ml-sm-4"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "color-gray-6 font-14 ml-n0 ml-md-n3 ml-sm-n0"
                        },
                        [_vm._v(" Usuario: ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "color-black font-16 ml-n0 ml-md-n3 ml-sm-n0"
                        },
                        [_vm._v(" " + _vm._s(item.user) + " ")]
                      )
                    ]
                  ),
                  _c("div", { staticClass: "col-md-8 col-sm-12 pl-5" }, [
                    _c("span", { staticClass: "color-gray-6 font-14" }, [
                      _vm._v("Fecha:")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(_vm._f("date")(item.date)) + " ")
                    ])
                  ]),
                  _vm.showDelete(item)
                    ? _c(
                        "div",
                        { staticClass: "delete-additional-payment" },
                        [
                          _c("action-button", {
                            staticClass: "outline-danger btn-block-xs-only",
                            attrs: {
                              i: "fas fa-times-circle",
                              text: "Eliminar"
                            },
                            on: {
                              click: function($event) {
                                return _vm.deleteAdditionalPayment(item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("em", { staticClass: "fas fa-plus-circle text-orange mr-2" }),
        _c("span", [_vm._v("Pago Adicional")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "fa-stack fa-1x color-secondary-25 font-14 mr-3" },
      [
        _c("em", { staticClass: "fas fa-circle fa-stack-2x" }),
        _c("em", { staticClass: "fas fa-dollar-sign fa-stack-1x fa-inverse" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }